import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "@/api/base";
import { SharepointItem } from "@/views/sharepoint/types";

const TAG = "sharepoint";

export const sharepointApi = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: "/pf-document/" }),
  reducerPath: "sharepointApi",
  tagTypes: [TAG],
  endpoints: builder => ({
    getSharepointItems: builder.query<
      {
        status: "login_required" | "success";
        files: SharepointItem[];
        is_root: boolean;
      },
      string | void
    >({
      providesTags: [TAG],
      query: folderId => ({
        url: "sharepoint",
        params: {
          folder_id: folderId,
        },
      }),
    }),
  }),
});

export const { useGetSharepointItemsQuery } = sharepointApi;
